export const ARTICLE = "/articles/";
export const ARTICLES = "/articles";
export const PRODUCTS = "/products";
export const COLLECTIONS = "?collectionId=";
export const PURCHASES = "/purchases";
export const WISHLIST = "/wishlist";
